<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div class="col-md-10 offset-md-1 pb-2" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.system.cisco_general_settings.description' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <!-- General Settings Section -->
    <h5 class="mb-3 mt-4">General Settings</h5>
    <div class="mb-3 list-group list-group-striped border-rad-all-12 card-shadow">
      @for (fieldKey of generalFields; track fieldKey) {
        <div class="list-group-item position-relative">
          @if (isCheckBox(formConfig.fields[fieldKey])) {
            <ziro-general-settings-checkbox [fieldId]="fieldKey"></ziro-general-settings-checkbox>
          }
          @if (isSelect(formConfig.fields[fieldKey])) {
            <ziro-general-settings-select [fieldId]="fieldKey"></ziro-general-settings-select>
          }
          @if (isTextInput(formConfig.fields[fieldKey])) {
            <ziro-general-settings-text [fieldId]="fieldKey"></ziro-general-settings-text>
          }
        </div>
      }
    </div>

    <!-- Self-Serve Page Settings Section -->
    <h5 class="mb-3 mt-4">Self-Serve Page Settings</h5>
    <div class="mb-3 list-group list-group-striped border-rad-all-12 card-shadow">
      @for (fieldKey of selfServeFields; track fieldKey) {
        <div class="list-group-item position-relative">
          @if (isCheckBox(formConfig.fields[fieldKey])) {
            <ziro-general-settings-checkbox [fieldId]="fieldKey"></ziro-general-settings-checkbox>
          }
          @if (isSelect(formConfig.fields[fieldKey])) {
            <ziro-general-settings-select [fieldId]="fieldKey"></ziro-general-settings-select>
          }
          @if (isTextInput(formConfig.fields[fieldKey])) {
            <ziro-general-settings-text [fieldId]="fieldKey"></ziro-general-settings-text>
          }
        </div>
      }
    </div>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
